'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.isFn = isFn;
exports.isThenable = isThenable;
exports.isObj = isObj;
/**
 * util
 */

function isFn(obj) {
	return typeof obj === 'function';
}

function isThenable(obj) {
	return obj != null && isFn(obj.then);
}

function isObj(obj) {
	return Object.prototype.toString.call(obj) === '[object Object]';
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/relite/lib/util.js
 ** module id = 186
 ** module chunks = 0
 **/